/* tslint:disable */
/* eslint-disable */
/**
 * ReportApiClient
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
// @ts-ignore
import { PostApplyToProductionRequest } from '../models';
// @ts-ignore
import { PostSaveDraftRequest } from '../models';
// @ts-ignore
import { ResponseWrapperOfObject } from '../models';
// @ts-ignore
import { ResponseWrapperOfObjectAndGetInitResponse } from '../models';
// @ts-ignore
import { ResponseWrapperOfObjectAndPostApplyToProductionResponse } from '../models';
// @ts-ignore
import { ResponseWrapperOfObjectAndPostPreviewResponse } from '../models';
// @ts-ignore
import { ResponseWrapperOfObjectAndPostSaveDraftResponse } from '../models';
/**
 * BffCustomReportsApi - axios parameter creator
 * @export
 */
export const BffCustomReportsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * # 詳細              初期表示データの返却 # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_002 | 対象テンプレート未登録 | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | S3ファイル削除済み | | MSG_ERROR_APPCOMMON_003 | ファイルのダウンロードに失敗 |
     * @summary 初期表示データの返却
     * @param {string} reportNameAlias 帳票名(別名)
     * @param {string} [templateVersion] 希望のバージョン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customReportsGetInit: async (
      reportNameAlias: string,
      templateVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'reportNameAlias' is not null or undefined
      assertParamExists(
        'customReportsGetInit',
        'reportNameAlias',
        reportNameAlias
      );
      const localVarPath =
        `/bff/v1/CustomReports/{reportNameAlias}/Init`.replace(
          `{${'reportNameAlias'}}`,
          encodeURIComponent(String(reportNameAlias))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication code required
      // oauth required
      await setOAuthToObject(
        localVarHeaderParameter,
        'code',
        [],
        configuration
      );

      // authentication jwt required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (templateVersion !== undefined) {
        localVarQueryParameter['templateVersion'] = templateVersion;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * # 詳細              テンプレートの本番適用する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録、データカタログ未登録、マッピング定義未登録、 オプション項目テストプリント用データセット未登録| | MSG_ERROR_COMMON_003 | 排他エラー | | MSG_ERROR_COMPILE_001 | 構文解析に失敗 | | MSG_ERROR_COMPILE_002 | コンパイルに失敗 | | MSG_ERROR_COMPILE_003 | コンパイルが許可されていない | | MSG_ERROR_APPCOMMON_007 | データカタログ、マッピング定義、オプション項目のテストプリント用データセットのフォーマットが不正 | | MSG_ERROR_RENDER_002 | テストプリント用データセットの生成に失敗 | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | ファイルが存在しない | | MSG_ERROR_APPCOMMON_003 | ファイルの読み込みに失敗 | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートの本番適用
     * @param {PostApplyToProductionRequest} postApplyToProductionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customReportsPostApplyToProduction: async (
      postApplyToProductionRequest: PostApplyToProductionRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'postApplyToProductionRequest' is not null or undefined
      assertParamExists(
        'customReportsPostApplyToProduction',
        'postApplyToProductionRequest',
        postApplyToProductionRequest
      );
      const localVarPath = `/bff/v1/CustomReports/ApplyToProduction`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication code required
      // oauth required
      await setOAuthToObject(
        localVarHeaderParameter,
        'code',
        [],
        configuration
      );

      // authentication jwt required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        postApplyToProductionRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * # 詳細              テンプレートのテスト印刷する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録、データカタログ未登録、マッピング定義未登録、 オプション項目テストプリント用データセット未登録| | MSG_ERROR_APPCOMMON_007 | データカタログ、マッピング定義、オプション項目のテストプリント用データセットのフォーマットが不正 | | MSG_ERROR_APPCOMMON_009 | テンプレートが本番適用済みのためテスト印刷不可 | | MSG_ERROR_RENDER_001 | 処理不可（帳票データの不整合） | | MSG_ERROR_RENDER_002 | テストプリント用データセットの生成に失敗 | | MSG_ERROR_COMPILE_001 | 構文解析に失敗 | | MSG_ERROR_COMPILE_002 | コンパイルに失敗 | | MSG_ERROR_COMPILE_003 | コンパイルが許可されていない | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | ファイルが存在しない | | MSG_ERROR_APPCOMMON_003 | ファイルの読み込みに失敗 | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートのテスト印刷
     * @param {number} [templateId]
     * @param {string} [outputType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customReportsPostPreview: async (
      templateId?: number,
      outputType?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/bff/v1/CustomReports/Preview`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new (
        (configuration && configuration.formDataCtor) ||
        FormData
      )();

      // authentication code required
      // oauth required
      await setOAuthToObject(
        localVarHeaderParameter,
        'code',
        [],
        configuration
      );

      // authentication jwt required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (templateId !== undefined) {
        localVarFormParams.append('TemplateId', templateId as any);
      }

      if (outputType !== undefined) {
        localVarFormParams.append('OutputType', outputType as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * # 詳細              テンプレートの一時保存する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録 | | MSG_ERROR_COMMON_003 | 排他エラー | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートの一時保存
     * @param {PostSaveDraftRequest} postSaveDraftRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customReportsPostSaveDraft: async (
      postSaveDraftRequest: PostSaveDraftRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'postSaveDraftRequest' is not null or undefined
      assertParamExists(
        'customReportsPostSaveDraft',
        'postSaveDraftRequest',
        postSaveDraftRequest
      );
      const localVarPath = `/bff/v1/CustomReports/SaveDraft`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication code required
      // oauth required
      await setOAuthToObject(
        localVarHeaderParameter,
        'code',
        [],
        configuration
      );

      // authentication jwt required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        postSaveDraftRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BffCustomReportsApi - functional programming interface
 * @export
 */
export const BffCustomReportsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    BffCustomReportsApiAxiosParamCreator(configuration);
  return {
    /**
     * # 詳細              初期表示データの返却 # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_002 | 対象テンプレート未登録 | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | S3ファイル削除済み | | MSG_ERROR_APPCOMMON_003 | ファイルのダウンロードに失敗 |
     * @summary 初期表示データの返却
     * @param {string} reportNameAlias 帳票名(別名)
     * @param {string} [templateVersion] 希望のバージョン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customReportsGetInit(
      reportNameAlias: string,
      templateVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ResponseWrapperOfObjectAndGetInitResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.customReportsGetInit(
          reportNameAlias,
          templateVersion,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * # 詳細              テンプレートの本番適用する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録、データカタログ未登録、マッピング定義未登録、 オプション項目テストプリント用データセット未登録| | MSG_ERROR_COMMON_003 | 排他エラー | | MSG_ERROR_COMPILE_001 | 構文解析に失敗 | | MSG_ERROR_COMPILE_002 | コンパイルに失敗 | | MSG_ERROR_COMPILE_003 | コンパイルが許可されていない | | MSG_ERROR_APPCOMMON_007 | データカタログ、マッピング定義、オプション項目のテストプリント用データセットのフォーマットが不正 | | MSG_ERROR_RENDER_002 | テストプリント用データセットの生成に失敗 | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | ファイルが存在しない | | MSG_ERROR_APPCOMMON_003 | ファイルの読み込みに失敗 | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートの本番適用
     * @param {PostApplyToProductionRequest} postApplyToProductionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customReportsPostApplyToProduction(
      postApplyToProductionRequest: PostApplyToProductionRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ResponseWrapperOfObjectAndPostApplyToProductionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.customReportsPostApplyToProduction(
          postApplyToProductionRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * # 詳細              テンプレートのテスト印刷する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録、データカタログ未登録、マッピング定義未登録、 オプション項目テストプリント用データセット未登録| | MSG_ERROR_APPCOMMON_007 | データカタログ、マッピング定義、オプション項目のテストプリント用データセットのフォーマットが不正 | | MSG_ERROR_APPCOMMON_009 | テンプレートが本番適用済みのためテスト印刷不可 | | MSG_ERROR_RENDER_001 | 処理不可（帳票データの不整合） | | MSG_ERROR_RENDER_002 | テストプリント用データセットの生成に失敗 | | MSG_ERROR_COMPILE_001 | 構文解析に失敗 | | MSG_ERROR_COMPILE_002 | コンパイルに失敗 | | MSG_ERROR_COMPILE_003 | コンパイルが許可されていない | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | ファイルが存在しない | | MSG_ERROR_APPCOMMON_003 | ファイルの読み込みに失敗 | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートのテスト印刷
     * @param {number} [templateId]
     * @param {string} [outputType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customReportsPostPreview(
      templateId?: number,
      outputType?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ResponseWrapperOfObjectAndPostPreviewResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.customReportsPostPreview(
          templateId,
          outputType,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * # 詳細              テンプレートの一時保存する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録 | | MSG_ERROR_COMMON_003 | 排他エラー | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートの一時保存
     * @param {PostSaveDraftRequest} postSaveDraftRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customReportsPostSaveDraft(
      postSaveDraftRequest: PostSaveDraftRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ResponseWrapperOfObjectAndPostSaveDraftResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.customReportsPostSaveDraft(
          postSaveDraftRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * BffCustomReportsApi - factory interface
 * @export
 */
export const BffCustomReportsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BffCustomReportsApiFp(configuration);
  return {
    /**
     * # 詳細              初期表示データの返却 # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_002 | 対象テンプレート未登録 | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | S3ファイル削除済み | | MSG_ERROR_APPCOMMON_003 | ファイルのダウンロードに失敗 |
     * @summary 初期表示データの返却
     * @param {string} reportNameAlias 帳票名(別名)
     * @param {string} [templateVersion] 希望のバージョン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customReportsGetInit(
      reportNameAlias: string,
      templateVersion?: string,
      options?: any
    ): AxiosPromise<ResponseWrapperOfObjectAndGetInitResponse> {
      return localVarFp
        .customReportsGetInit(reportNameAlias, templateVersion, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * # 詳細              テンプレートの本番適用する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録、データカタログ未登録、マッピング定義未登録、 オプション項目テストプリント用データセット未登録| | MSG_ERROR_COMMON_003 | 排他エラー | | MSG_ERROR_COMPILE_001 | 構文解析に失敗 | | MSG_ERROR_COMPILE_002 | コンパイルに失敗 | | MSG_ERROR_COMPILE_003 | コンパイルが許可されていない | | MSG_ERROR_APPCOMMON_007 | データカタログ、マッピング定義、オプション項目のテストプリント用データセットのフォーマットが不正 | | MSG_ERROR_RENDER_002 | テストプリント用データセットの生成に失敗 | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | ファイルが存在しない | | MSG_ERROR_APPCOMMON_003 | ファイルの読み込みに失敗 | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートの本番適用
     * @param {PostApplyToProductionRequest} postApplyToProductionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customReportsPostApplyToProduction(
      postApplyToProductionRequest: PostApplyToProductionRequest,
      options?: any
    ): AxiosPromise<ResponseWrapperOfObjectAndPostApplyToProductionResponse> {
      return localVarFp
        .customReportsPostApplyToProduction(
          postApplyToProductionRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * # 詳細              テンプレートのテスト印刷する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録、データカタログ未登録、マッピング定義未登録、 オプション項目テストプリント用データセット未登録| | MSG_ERROR_APPCOMMON_007 | データカタログ、マッピング定義、オプション項目のテストプリント用データセットのフォーマットが不正 | | MSG_ERROR_APPCOMMON_009 | テンプレートが本番適用済みのためテスト印刷不可 | | MSG_ERROR_RENDER_001 | 処理不可（帳票データの不整合） | | MSG_ERROR_RENDER_002 | テストプリント用データセットの生成に失敗 | | MSG_ERROR_COMPILE_001 | 構文解析に失敗 | | MSG_ERROR_COMPILE_002 | コンパイルに失敗 | | MSG_ERROR_COMPILE_003 | コンパイルが許可されていない | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | ファイルが存在しない | | MSG_ERROR_APPCOMMON_003 | ファイルの読み込みに失敗 | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートのテスト印刷
     * @param {number} [templateId]
     * @param {string} [outputType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customReportsPostPreview(
      templateId?: number,
      outputType?: string,
      options?: any
    ): AxiosPromise<ResponseWrapperOfObjectAndPostPreviewResponse> {
      return localVarFp
        .customReportsPostPreview(templateId, outputType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * # 詳細              テンプレートの一時保存する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録 | | MSG_ERROR_COMMON_003 | 排他エラー | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
     * @summary テンプレートの一時保存
     * @param {PostSaveDraftRequest} postSaveDraftRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customReportsPostSaveDraft(
      postSaveDraftRequest: PostSaveDraftRequest,
      options?: any
    ): AxiosPromise<ResponseWrapperOfObjectAndPostSaveDraftResponse> {
      return localVarFp
        .customReportsPostSaveDraft(postSaveDraftRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * BffCustomReportsApi - object-oriented interface
 * @export
 * @class BffCustomReportsApi
 * @extends {BaseAPI}
 */
export class BffCustomReportsApi extends BaseAPI {
  /**
   * # 詳細              初期表示データの返却 # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_002 | 対象テンプレート未登録 | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | S3ファイル削除済み | | MSG_ERROR_APPCOMMON_003 | ファイルのダウンロードに失敗 |
   * @summary 初期表示データの返却
   * @param {string} reportNameAlias 帳票名(別名)
   * @param {string} [templateVersion] 希望のバージョン
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BffCustomReportsApi
   */
  public customReportsGetInit(
    reportNameAlias: string,
    templateVersion?: string,
    options?: AxiosRequestConfig
  ) {
    return BffCustomReportsApiFp(this.configuration)
      .customReportsGetInit(reportNameAlias, templateVersion, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * # 詳細              テンプレートの本番適用する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録、データカタログ未登録、マッピング定義未登録、 オプション項目テストプリント用データセット未登録| | MSG_ERROR_COMMON_003 | 排他エラー | | MSG_ERROR_COMPILE_001 | 構文解析に失敗 | | MSG_ERROR_COMPILE_002 | コンパイルに失敗 | | MSG_ERROR_COMPILE_003 | コンパイルが許可されていない | | MSG_ERROR_APPCOMMON_007 | データカタログ、マッピング定義、オプション項目のテストプリント用データセットのフォーマットが不正 | | MSG_ERROR_RENDER_002 | テストプリント用データセットの生成に失敗 | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | ファイルが存在しない | | MSG_ERROR_APPCOMMON_003 | ファイルの読み込みに失敗 | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
   * @summary テンプレートの本番適用
   * @param {PostApplyToProductionRequest} postApplyToProductionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BffCustomReportsApi
   */
  public customReportsPostApplyToProduction(
    postApplyToProductionRequest: PostApplyToProductionRequest,
    options?: AxiosRequestConfig
  ) {
    return BffCustomReportsApiFp(this.configuration)
      .customReportsPostApplyToProduction(postApplyToProductionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * # 詳細              テンプレートのテスト印刷する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録、データカタログ未登録、マッピング定義未登録、 オプション項目テストプリント用データセット未登録| | MSG_ERROR_APPCOMMON_007 | データカタログ、マッピング定義、オプション項目のテストプリント用データセットのフォーマットが不正 | | MSG_ERROR_APPCOMMON_009 | テンプレートが本番適用済みのためテスト印刷不可 | | MSG_ERROR_RENDER_001 | 処理不可（帳票データの不整合） | | MSG_ERROR_RENDER_002 | テストプリント用データセットの生成に失敗 | | MSG_ERROR_COMPILE_001 | 構文解析に失敗 | | MSG_ERROR_COMPILE_002 | コンパイルに失敗 | | MSG_ERROR_COMPILE_003 | コンパイルが許可されていない | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_002 | ファイルが存在しない | | MSG_ERROR_APPCOMMON_003 | ファイルの読み込みに失敗 | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
   * @summary テンプレートのテスト印刷
   * @param {number} [templateId]
   * @param {string} [outputType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BffCustomReportsApi
   */
  public customReportsPostPreview(
    templateId?: number,
    outputType?: string,
    options?: AxiosRequestConfig
  ) {
    return BffCustomReportsApiFp(this.configuration)
      .customReportsPostPreview(templateId, outputType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * # 詳細              テンプレートの一時保存する # レスポンス # 業務エラー（HTTPステータス：400） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_001 | 権限エラー | | MSG_ERROR_COMMON_002 | テンプレート未登録 | | MSG_ERROR_COMMON_003 | 排他エラー | # システムエラー（HTTPステータス：500） | エラーコード | エラー説明 | | - | - | | MSG_ERROR_COMMON_004 | サーバーエラー | | MSG_ERROR_APPCOMMON_004 | ファイルのアップロードに失敗 |
   * @summary テンプレートの一時保存
   * @param {PostSaveDraftRequest} postSaveDraftRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BffCustomReportsApi
   */
  public customReportsPostSaveDraft(
    postSaveDraftRequest: PostSaveDraftRequest,
    options?: AxiosRequestConfig
  ) {
    return BffCustomReportsApiFp(this.configuration)
      .customReportsPostSaveDraft(postSaveDraftRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
